import useHelpers from 'hooks/helpers';
import { Text, RichText, Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

const KeyHighlightItem = ({ fields, rendering, idx }) => {
  const { anchorId } = useHelpers(rendering);
  return (
    <div id={anchorId} className="key-highlight-item">
      <Text tag="h4" className="h4 background-to-change" field={fields.title} />
      <RichText className="body-default background-to-change mt-2" fields={fields} />
      <Placeholder
        name={`abrdn-key-highlight-item-${idx}`}
        rendering={rendering}
        className="mt-2"
      />
    </div>
  );
};

export default KeyHighlightItem;
